import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    activeValidationsPersonaJuridica
} from "../../redux/person/personLegalSlice";

import {
    activeValidationsPersonaDocumento,
    setPersonaDocumentos,
    defaultPersonaDocumentos
} from "../../redux/person/personDocumentSlice";

import {
    setPersonaDirecciones,
    defaultPersonaDirecciones
} from "../../redux/person/personDirectionSlice";

import {
    setPersonaContactos,
    defaultPersonaContactos
} from "../../redux/person/personContactSlice";

import {
    setEntity as setPersonRepresentative,
    defaultEntity as defaultPersonRepresentative
} from "../../redux/person/personRepresentativeSlice";

import * as personaService from "../../services/personaService";
import { puedeEditarPagina } from "../../services/permisoService";
import {
    notifySuccess,
    notifyWarning,
    notifyError
} from "../../services/notificationService";

export const usePersonLegalForm = (sliceKey) => {
    const dispatch = useDispatch();
    const EMPTY_ARRAY = [];

    const mainEntity = useSelector(
        state => state.personLegal[sliceKey]?.entity
    );

    const personaDirecciones = useSelector(
        state => state.personDirection[sliceKey]?.personaDirecciones
    );

    const personaDocumentos = useSelector(
        state => state.personDocument[sliceKey]?.personaDocumentos
    );

    const personaContactos = useSelector(
        state => state.personContact[sliceKey]?.personaContactos
    );

    const personRepresentative = useSelector(
        state => state.personRepresentative[sliceKey]?.entity
    );

    const mainEntityValidation = useSelector(
        state => state.personLegal[sliceKey]?.validationMessage ?? EMPTY_ARRAY
    );

    const personaDocumentosValidation = useSelector(
        state => state.personDocument[sliceKey]?.validationMessage ?? EMPTY_ARRAY
    );

    // La pagina solo se puede editar si el usuario tiene el permiso de Persona.
    const [isReadOnly, setIsReadOnly] = useState(!puedeEditarPagina("persona"));
    const [idNew, setIdNew] = useState(0);

    const buildPayload = () => ({
        ...mainEntity,
        nombres: mainEntity.razonSocial,
        personaDireccion: personaDirecciones,
        personaDocumento: personaDocumentos,
        personaContacto: personaContactos,
        PersonaRepresentante: personRepresentative,
    });

    const reloadDetails = async (personId) => {
        const directions =
            await personaService.getsPersonaDireccionView(personId);

        const contacts =
            await personaService.getsPersonaContactoView(personId);

        const documents =
            await personaService.getsPersonaDocumentoView(personId);

        const representatives =
            await personaService.GetsPersonaRepresentanteViewById(personId);

        dispatch(setPersonaDirecciones({
            sliceKey,
            data: directions?.length
                ? directions
                : defaultPersonaDirecciones
        }));

        dispatch(setPersonaContactos({
            sliceKey,
            data: contacts?.length
                ? contacts
                : defaultPersonaContactos
        }));

        dispatch(setPersonaDocumentos({
            sliceKey,
            data: documents?.length
                ? documents
                : defaultPersonaDocumentos
        }));

        dispatch(setPersonRepresentative({
            sliceKey,
            data: representatives?.length
                ? representatives
                : defaultPersonRepresentative
        }));
    };

    const save = async () => {
        const validationMessages =
            mainEntityValidation.concat(personaDocumentosValidation);

        if (validationMessages.length > 0) {
            dispatch(activeValidationsPersonaJuridica({ sliceKey }));
            dispatch(activeValidationsPersonaDocumento({ sliceKey }));

            notifyWarning(validationMessages.join(" - "));
            return null;
        }

        try {
            const dataPost = buildPayload();

            const response =
                await personaService.postPersonaJuridicaUpdateWithDetails(dataPost);

            const newId = parseInt(response.data.data);

            notifySuccess("Se guardaron los datos con éxito");

            setIdNew(newId);
            setIsReadOnly(true);

            if (mainEntity?.id > 0) {
                await reloadDetails(mainEntity.id);
            }

            return {
                ...dataPost,
                id: newId,
            };
        }
        catch (error) {
            notifyError(
                error.response?.data?.message ??
                error.message ??
                "An unexpected error occurred."
            );

            return null;
        }
    };

    return {
        mainEntity,
        isReadOnly,
        setIsReadOnly,
        idNew,
        save
    };
};
